import * as React from "react";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface NavDropdownItem {
  to: string;
  label: string;
}

interface IProps {
  label: string;
  items: NavDropdownItem[];
}

const NavDropdown = ({ label, items }: IProps) => {
  const navigate = useNavigate();

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="link"
        className="text-white fs-6 text-decoration-none border-0 shadow-none"
      >
        {label}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {items.map(({ to, label }) => (
          <Dropdown.Item
            key={to}
            onClick={() => navigate(to)}
          >
            {label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavDropdown;
